import React from 'react';
import { useTranslation } from 'react-i18next';

function FeelCard({ emoji, modifier, title, classes, isPositive }) {
  const { t } = useTranslation();
  const isReversed = modifier === 'isReversed';
  const effectivePositive = isReversed ? !isPositive : isPositive;
  return (
    <>
    {/* isPositive * modifier=not means the card is negative or positive   */}
      <div className={"card card--feel " + classes + (effectivePositive ? " card--feel_pleasant" : " card--feel_unpleasant")}> 
        <div className="card__icon card__icon--feel"></div>
        <div className="card__emoji">{emoji}</div>
        <div className="card__not--stroke">{modifier === `isReversed` && t(`card.not`)}</div>
        <div className="card__not">{modifier === `isReversed` && t(`card.not`)}</div>
        <div className="card__a-little--stroke">{modifier === `isReduced` && t(`card.alittle`)}</div>
        <div className="card__a-little">{modifier === `isReduced` && t(`card.alittle`)}</div>
        <div className="card__title">{t(`cards.FEEL.${title}.title`)}</div>
      </div>
    </>
  );
}

export default FeelCard;
